import { WireAdapter, ShadowRootTheGoodPart } from "lwc";
import debounce from "lodash/debounce";

export type ElementResizeAdapterConfig = {
  options?: ResizeObserverOptions;
  template: ShadowRootTheGoodPart;
};

export class ResizeObserverAdapter implements WireAdapter {
  private observer: ResizeObserver | null = null;

  private setValue: (entry: ResizeObserverEntry) => void;

  constructor(setValue: (entries: ResizeObserverEntry) => void) {
    this.setValue = setValue;
  }

  connect() {}

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  update(config: ElementResizeAdapterConfig) {
    if (!this.observer) {
      // @ts-ignore
      this.observer = new ResizeObserver(
        debounce((entries: ResizeObserverEntry[]) => {
          this.setValue(entries[0]);
        }, 250)
      );
      this.observer!.observe(config.template.host, config.options);
    }
  }
}

export interface ResizeObserver {
  new (callback: ResizeObserverCallback): ResizeObserver;
  disconnect(): void;
  observe(target: Element, options?: ResizeObserverOptions): void;
  unobserve(target: Element): void;
}

export interface ResizeObserverCallback {
  (entries: ResizeObserverEntry[], observer: ResizeObserver): void;
}

interface ResizeObserverOptions {
  box?: "content-box" | "border-box" | "device-pixel-content-box";
}

interface ResizeObserverSize {
  readonly inlineSize: number;
  readonly blockSize: number;
}

export interface ResizeObserverEntry {
  readonly target: Element;
  readonly contentRect: DOMRectReadOnly;
  readonly borderBoxSize: ReadonlyArray<ResizeObserverSize>;
  readonly contentBoxSize: ReadonlyArray<ResizeObserverSize>;
  readonly devicePixelContentBoxSize?: ReadonlyArray<ResizeObserverSize>;
}
